module.exports = __webpack_public_path__ + "img/icon_food.440aa759.svg";